export const servicePages = {
  'rozwod-wroclaw': {
    eyebrow: 'Prawo rodzinne',
    title: 'Rozwód we Wrocławiu — pomoc radcy prawnego',
    seoTitle: 'Rozwód Wrocław – pomoc radcy prawnego | Magdalena Pawlak',
    seoDescription:
      'Pomoc prawna w sprawach rozwodowych we Wrocławiu: pozew i odpowiedź na pozew, wina, dzieci, alimenty, kontakty, zabezpieczenie i mediacja.',
    intro:
      'Pomagam przygotować pozew lub odpowiedź na pozew, uporządkować sprawy dotyczące dzieci i wybrać sposób prowadzenia postępowania — od próby uzgodnienia stanowisk po reprezentację w sporze sądowym.',
    situations: [
      'rozwód bez orzekania o winie albo z żądaniem ustalenia winy',
      'przygotowanie pozwu, odpowiedzi na pozew i dalszych pism',
      'władza rodzicielska, miejsce pobytu dziecka, kontakty i alimenty',
      'wnioski o zabezpieczenie sytuacji rodziny na czas procesu',
      'porozumienie rodzicielskie, negocjacje i mediacja',
      'reprezentacja przed sądem oraz analiza otrzymanego wyroku',
    ],
    documents: [
      'odpis aktu małżeństwa oraz akty urodzenia wspólnych małoletnich dzieci',
      'otrzymany pozew, wezwania i inne pisma sądowe',
      'krótka chronologia rozstania oraz informacja o stanowisku drugiego małżonka',
      'propozycja ustaleń dotyczących dzieci i zestawienie ich potrzeb',
      'dokumenty finansowe oraz materiały związane z planowanymi żądaniami i dowodami',
    ],
    documentNotice:
      'W pierwszej wiadomości wystarczy wskazać, czy pozew został już wniesiony lub doręczony, czy są wspólne małoletnie dzieci i które kwestie pozostają sporne. Intymnych opisów, danych dzieci i pełnych akt nie trzeba przesyłać przez zwykły formularz — sposób przekazania dokumentów najlepiej uzgodnić z kancelarią.',
    contentSections: [
      {
        title: 'Kiedy sąd może orzec rozwód?',
        paragraphs: [
          'Podstawą rozwodu jest zupełny i trwały rozkład pożycia małżeńskiego. Samo osobne zamieszkanie nie przesądza jeszcze, że przesłanki te są spełnione. Sąd bada sytuację stron, a także ustawowe przeszkody, w tym dobro wspólnych małoletnich dzieci.',
          'Jeżeli jeden z małżonków nie zgadza się na rozwód, nie oznacza to automatycznie zakończenia sprawy. Znaczenie mają przyczyny rozkładu, stanowiska stron i ograniczenia przewidziane w ustawie, zwłaszcza gdy rozwodu żąda małżonek wyłącznie winny.',
        ],
      },
      {
        title: 'Rozwód bez orzekania o winie i z orzekaniem o winie',
        paragraphs: [
          'Sąd zaniecha orzekania o winie tylko na zgodne żądanie obojga małżonków. Zgoda na samo rozwiązanie małżeństwa nie jest jeszcze zgodnym stanowiskiem w sprawie winy. Jeżeli takiego żądania nie ma, sąd co do zasady rozstrzyga, czy i który z małżonków ponosi winę za rozkład pożycia.',
          'Wybór stanowiska wpływa na zakres postępowania dowodowego i może mieć znaczenie dla ewentualnych alimentów między byłymi małżonkami. Orzeczenie wyłącznej winy nie powoduje jednak automatycznie zasądzenia alimentów — odrębnie trzeba wykazać przesłanki konkretnego roszczenia.',
        ],
      },
      {
        title: 'Rozwód a wspólne małoletnie dzieci',
        paragraphs: [
          'W wyroku rozwodowym sąd rozstrzyga o władzy rodzicielskiej, kontaktach oraz ponoszeniu kosztów utrzymania i wychowania wspólnych małoletnich dzieci. W praktyce stanowisko stron powinno również jasno przedstawiać proponowane miejsce pobytu dziecka i sposób wykonywania opieki.',
          'Pisemne porozumienie rodziców może ograniczyć zakres sporu, jeżeli pozostaje zgodne z dobrem dziecka. Na zgodny wniosek stron sąd może nie orzekać o utrzymywaniu kontaktów, ale nie zwalnia go to z pozostałych obowiązkowych rozstrzygnięć dotyczących dziecka.',
        ],
        points: [
          'sposób wykonywania władzy rodzicielskiej i codziennej opieki',
          'miejsce pobytu dziecka oraz harmonogram kontaktów',
          'koszty utrzymania i wychowania dziecka',
          'rozwiązania potrzebne na czas trwania postępowania',
        ],
      },
      {
        title: 'Zabezpieczenie na czas sprawy i mediacja',
        paragraphs: [
          'Postępowanie rozwodowe może trwać, dlatego w odpowiedniej sytuacji można rozważyć wniosek o tymczasowe uregulowanie alimentów, kontaktów, miejsca pobytu dziecka albo innych pilnych kwestii. Treść i podstawa zabezpieczenia zależą od rzeczywistej potrzeby — nie istnieje jeden uniwersalny wniosek dla każdej rodziny.',
          'Mediacja jest możliwa także po rozpoczęciu procesu. Może pomóc uzgodnić między innymi alimenty, wykonywanie władzy rodzicielskiej, kontakty i wybrane sprawy majątkowe podlegające rozstrzygnięciu w wyroku. Porozumienie nie zastępuje jednak wyroku rozwodowego ani kontroli dobra dziecka przez sąd.',
        ],
      },
      {
        title: 'Pozew o rozwód we Wrocławiu: sąd i opłata',
        paragraphs: [
          'Sprawy rozwodowe rozpoznaje sąd okręgowy. Właściwość miejscową ustala się w ustawowej kolejności: w pierwszej kolejności znaczenie ma ostatnie wspólne miejsce zamieszkania małżonków i to, czy jedno z nich nadal mieszka lub zwykle przebywa w tym okręgu. Sam obecny adres powoda we Wrocławiu nie zawsze wystarczy.',
          'Jeżeli te zasady wskazują Wrocław, sprawy rodzinne rozpoznaje Sąd Okręgowy we Wrocławiu. Aktualna opłata stała od pozwu o rozwód wynosi 600 zł. Dodatkowe koszty mogą zależeć od żądań, dowodów, mediacji, pełnomocnika lub zaskarżenia. W określonych okolicznościach można wnioskować o zwolnienie od kosztów sądowych.',
        ],
        note:
          'Adres sądu, właściwy wydział, sposób wniesienia pisma i wysokość opłat należy ponownie sprawdzić przed złożeniem pozwu. Adres e-mail sądu nie powinien być traktowany jako potwierdzony kanał skutecznego wniesienia pozwu.',
      },
      {
        title: 'Dowody, czas postępowania i podział majątku',
        paragraphs: [
          'Zakres dowodów zależy od tego, które fakty i żądania są sporne. Znaczenie mogą mieć dokumenty, zeznania świadków, przesłuchanie stron i inne dowody dobrane do sprawy. Gotowy wzór pozwu nie rozstrzyga, jakie stanowisko będzie bezpieczne ani które materiały należy powołać.',
          'Nie można zagwarantować liczby rozpraw ani daty wyroku. Czas postępowania zależy między innymi od zakresu sporu, dowodów, sytuacji dzieci i organizacji pracy sądu. Podział majątku może zostać przeprowadzony w wyroku rozwodowym tylko wtedy, gdy nie spowoduje nadmiernej zwłoki; w wielu sprawach pozostaje odrębnym postępowaniem.',
        ],
      },
    ],
    faqHeading: 'O co najczęściej pytają małżonkowie?',
    faqs: [
      {
        question: 'Czy samo osobne mieszkanie wystarczy do rozwodu?',
        answer:
          'Nie. Ustawową przesłanką jest zupełny i trwały rozkład pożycia. Osobne zamieszkanie może być jedną z okoliczności, ale sąd ocenia całą sytuację oraz ustawowe przeszkody rozwodowe.',
      },
      {
        question: 'Czy drugi małżonek musi zgodzić się na rozwód?',
        answer:
          'Brak zgody nie zawsze uniemożliwia rozwód. Sąd bada jednak wszystkie przesłanki i ograniczenia ustawowe, w tym szczególną sytuację, gdy rozwodu żąda małżonek wyłącznie winny rozkładu pożycia.',
      },
      {
        question: 'Czy do rozwodu bez orzekania o winie potrzebna jest zgoda obu stron?',
        answer:
          'Tak. Sąd zaniecha orzekania o winie na zgodne żądanie małżonków. Jednostronne stanowisko zawarte w pozwie nie wystarczy, jeśli drugi małżonek domaga się ustalenia winy.',
      },
      {
        question: 'Czy wyłączna wina drugiego małżonka gwarantuje alimenty?',
        answer:
          'Nie. Orzeczenie winy może mieć znaczenie dla podstawy alimentów między byłymi małżonkami, ale świadczenie wymaga odrębnego żądania i wykazania przesłanek przewidzianych w ustawie.',
      },
      {
        question: 'Co sąd ustala w sprawie wspólnych małoletnich dzieci?',
        answer:
          'Wyrok obejmuje władzę rodzicielską, kontakty oraz ponoszenie kosztów utrzymania i wychowania dzieci. Stanowisko rodziców powinno również jasno określać proponowane miejsce pobytu i sposób codziennej opieki.',
      },
      {
        question: 'Czy można skorzystać z mediacji po wniesieniu pozwu?',
        answer:
          'Tak. Mediacja może służyć uzgodnieniu spornych kwestii także w toku procesu, lecz sam rozwód nadal orzeka sąd po zbadaniu ustawowych przesłanek.',
      },
      {
        question: 'Ile kosztuje złożenie pozwu o rozwód?',
        answer:
          'Aktualna opłata stała od pozwu wynosi 600 zł. Ustawa przewiduje zwrot połowy tej opłaty, jeżeli rozwód zostanie orzeczony na zgodny wniosek stron bez orzekania o winie. Mogą pojawić się również inne koszty zależne od przebiegu i żądań w sprawie.',
      },
      {
        question: 'Ile trwa rozwód we Wrocławiu?',
        answer:
          'Nie ma jednego terminu dla wszystkich spraw. Liczba rozpraw i czas postępowania zależą między innymi od zakresu sporu, dowodów, stanowisk dotyczących dzieci oraz aktualnej organizacji pracy sądu.',
      },
      {
        question: 'Czy sąd podzieli majątek podczas rozwodu?',
        answer:
          'Może to zrobić na wniosek jednego z małżonków, jeśli przeprowadzenie podziału nie spowoduje nadmiernej zwłoki. W sprawach wymagających szerszego postępowania dowodowego podział majątku jest zwykle prowadzony osobno.',
      },
    ],
    relatedServices: [
      {
        label: 'Alimenty we Wrocławiu',
        to: '/uslugi/alimenty-wroclaw',
      },
      {
        label: 'Kontakty z dzieckiem',
        to: '/uslugi/kontakty-z-dzieckiem',
      },
      {
        label: 'Podział majątku po rozwodzie',
        to: '/uslugi/podzial-majatku',
      },
    ],
  },
  'alimenty-wroclaw': {
    eyebrow: 'Prawo rodzinne',
    title: 'Alimenty we Wrocławiu',
    intro:
      'Prowadzę sprawy o ustalenie, podwyższenie i obniżenie alimentów oraz pomagam uporządkować koszty, dokumenty i dowody potrzebne do oceny sytuacji.',
    situations: [
      'pozew o alimenty i wniosek o zabezpieczenie',
      'podwyższenie albo obniżenie wcześniej ustalonej kwoty',
      'alimenty w sprawie rozwodowej i przy opiece naprzemiennej',
      'ocena obowiązku wobec pełnoletniego dziecka lub małżonka',
    ],
    documents: [
      'orzeczenia i ugody dotyczące alimentów',
      'zestawienie kosztów utrzymania dziecka lub uprawnionego',
      'rachunki, faktury i potwierdzenia regularnych wydatków',
      'dokumenty dotyczące dochodów i możliwości zarobkowych stron',
    ],
  },
  'podzial-majatku': {
    eyebrow: 'Prawo rodzinne',
    title: 'Podział majątku po rozwodzie',
    intro:
      'Pomagam ustalić skład majątku, rozliczyć nakłady i przygotować rozwiązanie ugodowe albo postępowanie sądowe dotyczące podziału majątku.',
    situations: [
      'podział mieszkania, domu, oszczędności lub innych składników',
      'rozliczenie kredytu, nakładów i wydatków z majątku osobistego',
      'ustalenie nierównych udziałów',
      'negocjowanie wysokości i terminu spłaty',
    ],
    documents: [
      'dokumenty własności i umowy kredytowe',
      'wykaz składników majątku oraz długów',
      'potwierdzenia nakładów, darowizn i wydatków',
      'wcześniejsze propozycje podziału lub korespondencja stron',
    ],
  },
  'kontakty-z-dzieckiem': {
    eyebrow: 'Prawo rodzinne',
    title: 'Kontakty z dzieckiem — ustalenie, zmiana i wykonywanie',
    seoTitle: 'Kontakty z dzieckiem Wrocław – pomoc prawna | Magdalena Pawlak',
    seoDescription:
      'Pomoc prawna w sprawach o ustalenie, zabezpieczenie, zmianę i wykonywanie kontaktów z dzieckiem. Harmonogram, wakacje, święta i kontakty na odległość.',
    intro:
      'Pomagam przygotować wykonalny plan kontaktów, podjąć próbę porozumienia albo przeprowadzić postępowanie dotyczące ich ustalenia, zmiany, zabezpieczenia lub wykonywania.',
    situations: [
      'ustalenie kontaktów po rozstaniu i przygotowanie szczegółowego planu',
      'zmiana wcześniejszego orzeczenia lub ugody',
      'zabezpieczenie kontaktów na czas postępowania',
      'utrudnianie albo niewykonywanie obowiązującego planu',
      'kontakty w weekendy, święta, wakacje i ferie',
      'rozmowy telefoniczne, wideo i kontakty przy dużej odległości',
    ],
    documents: [
      'orzeczenia, ugody i zabezpieczenia dotyczące dziecka',
      'proponowany harmonogram z godzinami, transportem, świętami i wakacjami',
      'krótka chronologia odbytych i niezrealizowanych kontaktów',
      'korespondencja dotycząca uzgodnień, zmian albo odmów',
      'informacje potrzebne do uwzględnienia szkoły, zajęć i codziennego rytmu dziecka',
    ],
    documentNotice:
      'W pierwszej wiadomości wystarczy podać orientacyjny wiek dziecka, miasto jego pobytu, informację o istniejącym orzeczeniu lub ugodzie i najbliższym pilnym terminie. PESEL-u, danych szkoły, dokumentacji zdrowotnej ani pełnych akt nie trzeba przesyłać przez zwykły formularz.',
    contentSections: [
      {
        title: 'Kontakty są odrębne od władzy rodzicielskiej',
        paragraphs: [
          'Rodzice i dziecko mają prawo oraz obowiązek utrzymywania ze sobą kontaktów niezależnie od władzy rodzicielskiej. Jej ograniczenie albo pozbawienie nie oznacza więc automatycznie zakazu spotkań. Zakres kontaktów podlega osobnej ocenie z punktu widzenia dobra dziecka.',
          'Kontakt to nie tylko osobiste spotkania i zabieranie dziecka poza miejsce stałego pobytu. Może obejmować również rozmowy, korespondencję oraz porozumiewanie się na odległość, w tym telefonicznie i przez komunikację elektroniczną.',
        ],
      },
      {
        title: 'Dobry plan powinien być konkretny i możliwy do wykonania',
        paragraphs: [
          'Ogólne sformułowanie „co drugi weekend” często nie wystarcza. Plan powinien odpowiadać wiekowi i potrzebom dziecka, odległości między rodzicami oraz jego codziennemu rytmowi. Warto ograniczyć niejasności, które później mogą prowadzić do kolejnych sporów.',
        ],
        points: [
          'dni oraz godziny rozpoczęcia i zakończenia kontaktu',
          'miejsce i sposób przekazania dziecka oraz odpowiedzialność za transport',
          'zasady dotyczące świąt, ferii, wakacji i ważnych rodzinnych wydarzeń',
          'pierwszeństwo terminów szczególnych wobec zwykłego harmonogramu',
          'częstotliwość i pory rozmów telefonicznych albo wideo',
          'sposób uzgadniania zmian i postępowania w razie choroby dziecka',
        ],
        note:
          'Nie istnieje jeden ustawowy model kontaktów właściwy dla każdej rodziny. Harmonogram trzeba dopasować do konkretnej sytuacji i dobra dziecka.',
      },
      {
        title: 'Porozumienie albo postępowanie sądowe',
        paragraphs: [
          'Jeżeli dziecko stale przebywa u jednego z rodziców, rodzice mogą wspólnie określić sposób kontaktów, kierując się jego dobrem i uwzględniając rozsądne życzenia dziecka. Pomocne mogą być negocjacje lub mediacja. Gdy porozumienie nie jest możliwe, rozstrzyga sąd opiekuńczy.',
          'W samodzielnej sprawie punktem wyjścia jest sąd rejonowy, wydział rodzinny i nieletnich, właściwy według miejsca zamieszkania dziecka, a przy jego braku — miejsca pobytu. Adres kancelarii ani obecny adres rodzica składającego wniosek nie przesądzają właściwości. Jeżeli trwa rozwód albo dziecko przebywa za granicą, właściwą drogę trzeba ustalić odrębnie.',
          'Urzędowa karta Ministerstwa Sprawiedliwości wskazuje obecnie opłatę stałą 100 zł od wniosku o uregulowanie kontaktów. Opłaty dotyczące zmiany, zabezpieczenia, wykonywania kontaktów lub środka zaskarżenia należy sprawdzić osobno na dzień składania pisma.',
        ],
      },
      {
        title: 'Zabezpieczenie kontaktów na czas postępowania',
        paragraphs: [
          'Jeżeli oczekiwanie na końcowe rozstrzygnięcie mogłoby utrwalić brak relacji albo pogłębić konflikt, można rozważyć wniosek o zabezpieczenie. Jest to tymczasowe uregulowanie sytuacji na czas trwania sprawy, a nie przesądzenie jej ostatecznego wyniku.',
          'Żądanie powinno przedstawiać konkretny i realny plan: daty lub sposób ich obliczania, godziny, przekazanie dziecka, transport, terminy szczególne i ewentualne kontakty zdalne. Złożenie wniosku nie gwarantuje jego uwzględnienia ani rozpoznania w określonym terminie.',
        ],
      },
      {
        title: 'Gdy orzeczenie lub ugoda nie są wykonywane',
        paragraphs: [
          'Postępowanie dotyczące wykonywania kontaktów wymaga wykonalnego orzeczenia albo odpowiedniej ugody sądowej lub zawartej przed mediatorem. Mechanizm jest dwuetapowy: najpierw sąd może zagrozić nakazaniem zapłaty określonej sumy za naruszenie, a przy dalszym niewykonywaniu obowiązków — nakazać zapłatę stosownie do stwierdzonych naruszeń. Nie jest to automatyczna grzywna za każdy nieodbyty kontakt.',
          'Trzeba sprawdzić dokładną treść planu, obowiązki każdej osoby i przyczyny konkretnego zdarzenia. Mechanizm może dotyczyć zarówno osoby sprawującej pieczę, jak i osoby uprawnionej do kontaktu, jeżeli to ona narusza obowiązki wynikające z tytułu.',
          'Sąd powinien również uwzględnić sytuację, w której kontakt nie dochodzi do skutku z powodu samodzielnego zachowania dziecka niewywołanego przez osobę sprawującą pieczę. Sama deklaracja „dziecko nie chce” nie rozstrzyga jednak automatycznie sprawy — konieczne jest ustalenie przyczyn i wpływu zachowań dorosłych.',
        ],
      },
      {
        title: 'Zmiana planu, przeprowadzka i kontakty na odległość',
        paragraphs: [
          'Wcześniejsze rozstrzygnięcie może zostać zmienione, jeżeli wymaga tego dobro dziecka. Powodem do ponownej analizy może być jego wiek, nowy plan szkoły i zajęć, przeprowadzka, zmiana sposobu opieki albo harmonogram, który w praktyce przestał działać.',
          'Przeprowadzka nie zmienia automatycznie dotychczasowego orzeczenia. Przy dużej odległości można rozważyć rzadsze, ale dłuższe spotkania, dokładne zasady transportu oraz regularne rozmowy zdalne. Gdy dziecko przebywa za granicą, trzeba osobno ustalić jurysdykcję i możliwość uznania lub wykonania wcześniejszego rozstrzygnięcia.',
        ],
      },
      {
        title: 'Dobro, bezpieczeństwo i głos dziecka',
        paragraphs: [
          'Dobro dziecka jest punktem odniesienia zarówno przy ustalaniu planu, jak i jego zmianie. Jego zdanie nie jest automatyczną decyzją o wyniku sprawy, ale powinno zostać uwzględnione odpowiednio do rozwoju, zdrowia i dojrzałości. Sąd może wysłuchać dziecko, jeżeli pozwalają na to te okoliczności.',
          'Jeżeli wymaga tego dobro dziecka, kontakty mogą zostać ograniczone, na przykład do spotkań w obecności wskazanej osoby albo do określonych form porozumiewania się na odległość. Gdy kontakty poważnie zagrażają dobru dziecka lub je naruszają, sąd może ich zakazać.',
        ],
        note:
          'W sytuacji bezpośredniego zagrożenia bezpieczeństwa dziecka należy skontaktować się z właściwymi służbami. Formularz kancelarii nie służy do zgłoszeń wymagających natychmiastowej interwencji.',
      },
    ],
    faqHeading: 'O co najczęściej pytają rodzice?',
    faqs: [
      {
        question: 'Czy rodzice muszą mieć wyrok, aby ustalić kontakty?',
        answer:
          'Nie zawsze. Rodzice mogą wspólnie określić sposób kontaktów. Jeżeli nie osiągną porozumienia albo potrzebują wykonalnego rozstrzygnięcia, sprawę może uregulować sąd opiekuńczy.',
      },
      {
        question: 'Czy pozbawienie władzy rodzicielskiej wyklucza kontakty?',
        answer:
          'Nie automatycznie. Kontakty są odrębne od władzy rodzicielskiej, choć sąd może je ograniczyć albo zakazać, jeżeli wymagają tego ustawowe przesłanki związane z dobrem dziecka.',
      },
      {
        question: 'Czy można ustalić rozmowy telefoniczne i wideo?',
        answer:
          'Tak. Kontakty obejmują również porozumiewanie się na odległość, w tym komunikację elektroniczną. Warto określić częstotliwość, pory i sposób połączeń odpowiedni do wieku oraz rytmu dnia dziecka.',
      },
      {
        question: 'Do jakiego sądu złożyć wniosek i jaka jest opłata?',
        answer:
          'W samodzielnej sprawie punktem wyjścia jest sąd rejonowy właściwy według miejsca zamieszkania dziecka, a przy jego braku — miejsca pobytu. Urzędowa karta MS wskazuje obecnie opłatę 100 zł za wniosek o uregulowanie kontaktów; inne tryby i pisma wymagają osobnego sprawdzenia.',
      },
      {
        question: 'Czy można uregulować kontakty jeszcze przed końcem sprawy?',
        answer:
          'Można rozważyć wniosek o zabezpieczenie na czas postępowania. Powinien zawierać konkretny i możliwy do wykonania plan, ale o jego uwzględnieniu oraz treści rozstrzyga sąd.',
      },
      {
        question: 'Co zrobić, gdy drugi rodzic nie wykonuje orzeczenia?',
        answer:
          'Najpierw trzeba sprawdzić treść wykonalnego orzeczenia lub ugody i udokumentować konkretne zdarzenia. Sądowy mechanizm wykonywania kontaktów ma odrębne etapy i nie oznacza automatycznej zapłaty za każdy niezrealizowany termin.',
      },
      {
        question: 'Co, jeśli dziecko odmawia spotkania?',
        answer:
          'Trzeba ustalić przyczyny odmowy i rolę zachowań dorosłych. Sąd powinien uwzględnić samodzielną wolę dziecka, odpowiednio do jego dojrzałości, ale samo stwierdzenie odmowy nie uchyla automatycznie obowiązującego planu.',
      },
      {
        question: 'Czy przeprowadzka automatycznie zmienia kontakty?',
        answer:
          'Nie. Jeżeli dotychczasowy plan przestał odpowiadać sytuacji i dobru dziecka, można wystąpić o jego zmianę. Osobno trzeba ustalić właściwy sąd i wpływ przeprowadzki na logistykę kontaktów.',
      },
      {
        question: 'Czy dziadkowie mogą domagać się kontaktów z dzieckiem?',
        answer:
          'Tak. Przepisy o kontaktach stosuje się odpowiednio między innymi do dziadków, rodzeństwa oraz niektórych innych osób, które przez dłuższy czas sprawowały pieczę nad dzieckiem.',
      },
    ],
    relatedServices: [
      {
        label: 'Rozwód we Wrocławiu',
        to: '/uslugi/rozwod-wroclaw',
      },
      {
        label: 'Alimenty we Wrocławiu',
        to: '/uslugi/alimenty-wroclaw',
      },
    ],
  },
  odszkodowania: {
    eyebrow: 'Odszkodowania',
    title: 'Odszkodowania po wypadkach — pomoc prawna we Wrocławiu',
    seoTitle: 'Odszkodowania Wrocław – pomoc prawna | Magdalena Pawlak',
    seoDescription:
      'Pomoc prawna w sprawach o odszkodowanie i zadośćuczynienie po wypadku. Analiza decyzji ubezpieczyciela, szkód osobowych i majątkowych oraz roszczeń do UFG.',
    intro:
      'Pomagam ustalić, jakie roszczenia mogą wynikać z wypadku lub innego zdarzenia, zgromadzić potrzebne dowody oraz ocenić decyzję ubezpieczyciela, propozycję ugody i dalszą drogę działania.',
    situations: [
      'obrażenia kierowcy, pasażera, pieszego lub rowerzysty',
      'koszty leczenia, rehabilitacji i opieki oraz utracone dochody',
      'uszkodzenie pojazdu, rzeczy osobistych lub innego mienia',
      'roszczenia bliskich osoby zmarłej wskutek zdarzenia',
      'odmowa albo zaniżenie świadczenia przez ubezpieczyciela',
      'szkoda spowodowana przez nieubezpieczonego lub nieustalonego sprawcę',
    ],
    documents: [
      'notatka Policji, oświadczenie sprawcy, zdjęcia oraz dane świadków',
      'zgłoszenie szkody, decyzje, kosztorysy i korespondencja z ubezpieczycielem',
      'dokumentacja leczenia, rehabilitacji i rokowania',
      'rachunki za leczenie, dojazdy, opiekę, naprawę i inne wydatki',
      'dokumenty dotyczące dochodów przed zdarzeniem i nieobecności w pracy',
    ],
    documentNotice:
      'W pierwszej wiadomości wystarczy krótko opisać zdarzenie, podać jego datę i wskazać, czy ubezpieczyciel wydał już decyzję. Sposób bezpiecznego przekazania dokumentacji medycznej najlepiej wcześniej uzgodnić z kancelarią.',
    contentSections: [
      {
        title: 'Jedno zdarzenie może powodować kilka rodzajów szkody',
        paragraphs: [
          'Uszkodzony samochód, uraz, przerwa w pracy i konieczność korzystania z pomocy innych osób nie tworzą jednego, automatycznie wyliczanego świadczenia. Każdy skutek zdarzenia trzeba nazwać, powiązać z wypadkiem i odpowiednio udokumentować.',
          'Odszkodowanie służy naprawieniu szkody majątkowej, natomiast zadośćuczynienie może dotyczyć krzywdy związanej z uszkodzeniem ciała lub rozstrojem zdrowia. Zakres roszczeń zależy od okoliczności konkretnej sprawy — nie istnieje urzędowa stawka za określony uraz.',
        ],
      },
      {
        title: 'Szkoda na osobie: koszty, dochody i codzienne funkcjonowanie',
        paragraphs: [
          'Analiza szkody osobowej nie powinna kończyć się na rachunkach za pierwsze leczenie. Znaczenie mogą mieć również koszty rehabilitacji, dojazdów, sprzętu, dostosowania codziennego funkcjonowania, a także wpływ urazu na możliwość pracy i przyszłe potrzeby.',
          'Pomoc świadczona nieodpłatnie przez rodzinę także może mieć znaczenie dla roszczenia. Trzeba jednak wykazać, że opieka była potrzebna, oraz ustalić jej rzeczywisty zakres. Przy długotrwałych następstwach osobno ocenia się przesłanki ewentualnej renty.',
        ],
        points: [
          'koszty leczenia, rehabilitacji, dojazdów i potrzebnego sprzętu',
          'utracone dochody oraz wpływ urazu na zdolność do pracy',
          'pomoc innych osób i zwiększone potrzeby w życiu codziennym',
          'krzywda, czas leczenia i trwałe albo długotrwałe następstwa urazu',
        ],
      },
      {
        title: 'Szkoda w pojeździe i innym mieniu',
        paragraphs: [
          'W sprawie dotyczącej pojazdu należy porównać stan sprzed szkody, zakres uszkodzeń, kosztorys i przyjęty sposób rozliczenia. W odpowiedniej sytuacji analiza może obejmować także celowe i ekonomicznie uzasadnione koszty pojazdu zastępczego lub inne straty pozostające w związku ze zdarzeniem.',
          'Każdy wydatek i okres korzystania z rozwiązania zastępczego wymaga oceny. Sama kolizja nie oznacza automatycznie zwrotu dowolnej ceny najmu ani wszystkich wskazanych kosztów.',
        ],
      },
      {
        title: 'Pasażer, pieszy i rowerzysta',
        paragraphs: [
          'O możliwość dochodzenia roszczeń mogą pytać nie tylko kierowcy. Pasażer — również podróżujący z osobą bliską — pieszy albo rowerzysta może być poszkodowanym. Pokrewieństwo z kierującym samo w sobie nie rozstrzyga sprawy.',
          'Trzeba ustalić przebieg zdarzenia, podmiot odpowiedzialny, właściwą polisę, zakres szkody oraz ewentualny wpływ zachowania poszkodowanego. Dlatego nie można z góry obiecać wypłaty ani określonej kwoty.',
        ],
      },
      {
        title: 'Gdy sprawca nie ma OC albo nie został ustalony',
        paragraphs: [
          'W określonych sytuacjach roszczenie może być kierowane do Ubezpieczeniowego Funduszu Gwarancyjnego. Brak obowiązkowego OC u zidentyfikowanego sprawcy i zdarzenie, w którym sprawcy nie udało się ustalić, to jednak dwa różne warianty.',
          'Przy nieustalonym sprawcy zakres odpowiedzialności za szkodę w mieniu jest ograniczony dodatkowymi warunkami. Przed zgłoszeniem warto więc ustalić, który wariant dotyczy sprawy i jakie dowody pozwalają wykazać przebieg oraz następstwa zdarzenia.',
        ],
      },
      {
        title: 'Decyzja ubezpieczyciela, reklamacja i ugoda',
        paragraphs: [
          'W sprawach z obowiązkowego OC ubezpieczyciel co do zasady powinien spełnić świadczenie w ciągu 30 dni od zawiadomienia o szkodzie. Jeżeli w tym czasie nie da się wyjaśnić całej sprawy, powinien między innymi wypłacić część bezsporną oraz poinformować o przyczynach i dalszym toku postępowania. Termin likwidacji szkody nie jest tym samym co termin przedawnienia roszczenia.',
          'Po niekorzystnej decyzji można przeanalizować reklamację, postępowanie przed Rzecznikiem Finansowym, negocjacje lub drogę sądową. Sam wniosek o interwencję Rzecznika Finansowego nie przerywa biegu przedawnienia.',
          'Przed podpisaniem ugody trzeba sprawdzić, jakie roszczenia i przyszłe następstwa obejmuje oraz z czego strony rezygnują. Nie należy zakładać, że późniejsza dopłata zawsze będzie możliwa.',
        ],
      },
      {
        title: 'Terminy trzeba ustalić dla konkretnego roszczenia',
        paragraphs: [
          'Nie każda sprawa przedawnia się po trzech latach. Znaczenie mogą mieć między innymi podstawa odpowiedzialności, charakter szkody, możliwość zakwalifikowania zdarzenia jako przestępstwa, wiek poszkodowanego oraz czynności podjęte wobec ubezpieczyciela.',
          'Jeżeli od zdarzenia minęło dużo czasu, trwa leczenie albo została przedstawiona ugoda z krótkim terminem odpowiedzi, warto przekazać kancelarii daty i dokumenty możliwie szybko. Ogólny poradnik nie zastąpi obliczenia terminu w konkretnej sprawie.',
        ],
      },
    ],
    faqHeading: 'O co najczęściej pytają poszkodowani?',
    faqs: [
      {
        question: 'Jak oblicza się wysokość odszkodowania lub zadośćuczynienia?',
        answer:
          'Nie ma jednej tabeli ani stawki za konkretny uraz. Osobno ustala się udokumentowane straty finansowe, koszty i utracone dochody, a przy zadośćuczynieniu — indywidualne następstwa zdarzenia i rozmiar krzywdy.',
      },
      {
        question: 'Czy pasażer może dochodzić roszczeń, jeśli prowadził członek rodziny?',
        answer:
          'Może istnieć taka możliwość. Pokrewieństwo nie wyklucza jej automatycznie, ale trzeba ustalić odpowiedzialność za zdarzenie, właściwą polisę, zakres szkody i pozostałe okoliczności przewozu.',
      },
      {
        question: 'Czy opieka zapewniona bezpłatnie przez rodzinę ma znaczenie?',
        answer:
          'Tak. Nieodpłatna opieka bliskich może być uwzględniona w roszczeniu, jeśli była potrzebna wskutek urazu. Należy wykazać jej rodzaj, częstotliwość i czas trwania.',
      },
      {
        question: 'Co zrobić, gdy sprawca nie miał OC albo uciekł?',
        answer:
          'Należy sprawdzić przesłanki odpowiedzialności Ubezpieczeniowego Funduszu Gwarancyjnego. Zasady są inne dla znanego sprawcy bez polisy i dla sprawcy nieustalonego; w tym drugim wariancie szkody w mieniu podlegają dodatkowym ograniczeniom.',
      },
      {
        question: 'Czy ubezpieczyciel zawsze ma 30 dni na zakończenie sprawy?',
        answer:
          'Trzydzieści dni od zawiadomienia to podstawowy termin spełnienia świadczenia z obowiązkowego OC. Ustawa przewiduje sytuacje wymagające dalszych wyjaśnień, ale bezsporna część świadczenia powinna zostać wypłacona w podstawowym terminie.',
      },
      {
        question: 'Czy warto podpisać ugodę zaproponowaną przez ubezpieczyciela?',
        answer:
          'Przed podpisaniem trzeba porównać kwotę z zakresem szkody i przeczytać, jakie obecne lub przyszłe roszczenia obejmuje ugoda. Jej zawarcie może ograniczyć możliwość późniejszego dochodzenia dalszych świadczeń.',
      },
      {
        question: 'Czy roszczenie zawsze przedawnia się po trzech latach?',
        answer:
          'Nie. Termin zależy od rodzaju szkody, podstawy odpowiedzialności i okoliczności sprawy, a szczególne zasady dotyczą między innymi szkód na osobie, zdarzeń będących przestępstwem i roszczeń małoletnich.',
      },
    ],
    relatedServices: [
      {
        label: 'Błędy medyczne',
        to: '/uslugi/bledy-medyczne',
      },
      {
        label: 'Umowy i spory cywilne',
        to: '/uslugi/prawo-cywilne',
      },
    ],
  },
  'bledy-medyczne': {
    eyebrow: 'Odszkodowania',
    title: 'Błędy medyczne — pomoc prawna we Wrocławiu',
    seoTitle: 'Błędy medyczne Wrocław – pomoc prawna | Magdalena Pawlak',
    seoDescription:
      'Pomoc prawna w sprawach dotyczących błędów medycznych, stomatologicznych i zabiegów medycyny estetycznej. Analiza dokumentacji, roszczeń i możliwych dróg działania.',
    intro:
      'Pomagam ocenić przebieg leczenia, uporządkować dokumentację i wybrać możliwą drogę działania w sprawach dotyczących szkód medycznych, stomatologii oraz zabiegów medycyny estetycznej.',
    situations: [
      'podejrzenie opóźnionej albo nieprawidłowej diagnozy',
      'nieprawidłowy przebieg leczenia, zabiegu lub opieki pooperacyjnej',
      'brak zrozumiałej informacji o ryzyku, alternatywach lub następstwach leczenia',
      'szkody związane z leczeniem stomatologicznym lub zabiegiem medycyny estetycznej',
    ],
    documents: [
      'wypisy, wyniki badań, opisy zabiegów, obrazy diagnostyczne i zalecenia',
      'formularze informacji i zgody podpisane przed leczeniem lub zabiegiem',
      'krótka chronologia leczenia, pogorszenia stanu zdrowia i dalszych konsultacji',
      'rachunki za leczenie, rehabilitację, opiekę i inne następstwa zdarzenia',
      'korespondencja z placówką, ubezpieczycielem lub Rzecznikiem Praw Pacjenta',
    ],
    documentNotice:
      'W pierwszej wiadomości wystarczy krótki opis zdarzenia i najważniejsze daty. Dokumentacja medyczna zawiera dane o zdrowiu — sposób jej bezpiecznego przekazania najlepiej najpierw uzgodnić z kancelarią.',
    faqHeading: 'O co pytają pacjenci?',
    contentSections: [
      {
        title: 'Niekorzystny wynik leczenia nie zawsze oznacza błąd',
        paragraphs: [
          'Powikłanie, niepowodzenie leczenia i możliwe uchybienie medyczne nie są pojęciami zamiennymi. Sam fakt pogorszenia zdrowia albo braku oczekiwanego efektu nie przesądza jeszcze o odpowiedzialności placówki lub osoby wykonującej zawód medyczny.',
          'Analiza prawna obejmuje zarówno sposób postępowania personelu, jak i związek między zdarzeniem a jego następstwami. Znaczenie mogą mieć również organizacja opieki, czas reakcji, przekazane zalecenia oraz to, czy pacjent otrzymał zrozumiałą informację przed wyrażeniem zgody.',
        ],
        points: [
          'co wydarzyło się na kolejnych etapach diagnostyki i leczenia',
          'czy postępowanie było zgodne z aktualną wiedzą medyczną',
          'jakie następstwa zdrowotne i finansowe pozostają w związku ze zdarzeniem',
          'który podmiot może odpowiadać za określone działanie lub zaniechanie',
        ],
      },
      {
        title: 'Informacja i świadoma zgoda pacjenta',
        paragraphs: [
          'Podpis pod formularzem nie zamyka automatycznie analizy sprawy. Zgoda powinna dotyczyć określonego świadczenia i być poprzedzona informacją przekazaną w sposób zrozumiały dla pacjenta. Istotne mogą być proponowane i możliwe metody leczenia, przewidywalne następstwa ich zastosowania lub zaniechania, ryzyko oraz dostępne alternatywy.',
          'Naruszenie prawa do informacji lub zgody jest innym zagadnieniem niż techniczna poprawność samego zabiegu. W konkretnej sprawie trzeba więc oddzielnie zbadać przebieg leczenia, zakres przekazanych informacji i następstwa dla pacjenta.',
        ],
      },
      {
        title: 'Jakich roszczeń może dotyczyć sprawa?',
        paragraphs: [
          'Rodzaj roszczenia zależy od ustalonej podstawy odpowiedzialności i rzeczywistych skutków zdarzenia. Analiza może dotyczyć szkody majątkowej, krzywdy, długotrwałych następstw zdrowotnych albo naruszenia praw pacjenta.',
        ],
        points: [
          'zwrot uzasadnionych kosztów leczenia, rehabilitacji, opieki lub dojazdów',
          'utracone dochody i inne możliwe do wykazania straty finansowe',
          'zadośćuczynienie za krzywdę związaną z uszkodzeniem ciała lub rozstrojem zdrowia',
          'renta, gdy zostały spełnione ustawowe przesłanki dotyczące zwiększonych potrzeb albo możliwości zarobkowania',
          'roszczenia związane z zawinionym naruszeniem praw pacjenta',
        ],
        note:
          'Nie istnieje jedna stawka za określony błąd. Zakres możliwych roszczeń oraz potrzebne dowody ocenia się indywidualnie.',
      },
      {
        title: 'Możliwe drogi działania',
        paragraphs: [
          'Nie każda sprawa wymaga rozpoczęcia od pozwu. Zależnie od rodzaju zdarzenia, miejsca leczenia, oczekiwanego rezultatu i dostępnych dowodów można rozważyć kontakt z placówką lub jej ubezpieczycielem, postępowanie przed Rzecznikiem Praw Pacjenta, Fundusz Kompensacyjny Zdarzeń Medycznych albo postępowanie cywilne.',
          'Fundusz Kompensacyjny jest szczególną, pozasądową drogą dla kwalifikujących się zdarzeń związanych z pobytem w szpitalu i świadczeniami finansowanymi ze środków publicznych. Nie obejmuje automatycznie każdego zabiegu ani każdej placówki. Przyjęcie świadczenia może również wpływać na możliwość dochodzenia określonych roszczeń, dlatego wybór tej drogi warto poprzedzić analizą.',
          'Poszczególne tryby mają różne terminy, wymagania i możliwe rezultaty. Złożenie skargi lub wniosku do jednego organu nie powinno być traktowane jako automatyczne zabezpieczenie wszystkich pozostałych roszczeń.',
        ],
      },
      {
        title: 'Stomatologia i medycyna estetyczna',
        paragraphs: [
          'W sprawach stomatologicznych i dotyczących medycyny estetycznej znaczenie ma nie tylko efekt zabiegu. Analizuje się także kwalifikację pacjenta, sposób przeprowadzenia procedury, plan leczenia, dokumentację stanu przed i po zabiegu, zalecenia oraz zakres przekazanej informacji.',
          'Niezadowolenie z rezultatu nie przesądza samo w sobie o odpowiedzialności. Podobnie podpisany formularz nie wyklucza dalszej analizy, jeżeli pojawiają się pytania o treść informacji, dobrowolność i zakres zgody albo sposób wykonania świadczenia.',
        ],
      },
      {
        title: 'Terminy wymagają indywidualnego sprawdzenia',
        paragraphs: [
          'Termin może zależeć między innymi od podstawy roszczenia, daty zdarzenia, momentu uzyskania wiedzy o szkodzie i osobie odpowiedzialnej, wieku poszkodowanego oraz wybranej drogi postępowania. Inne zasady dotyczą roszczeń cywilnych, a inne wniosku do Funduszu Kompensacyjnego.',
          'Jeśli leczenie miało miejsce wcześniej albo zbliża się termin wskazany w decyzji lub piśmie, warto przekazać kancelarii daty i dokumenty możliwie szybko, zamiast obliczać termin wyłącznie na podstawie ogólnego poradnika.',
        ],
      },
    ],
    faqs: [
      {
        question: 'Czy każde powikłanie oznacza błąd medyczny?',
        answer:
          'Nie. Powikłanie może wystąpić mimo prawidłowego postępowania. Trzeba jednak sprawdzić, czy ryzyko było przewidywalne, czy pacjent został o nim właściwie poinformowany oraz czy diagnostyka, leczenie i reakcja na pogorszenie stanu zdrowia były prawidłowe.',
      },
      {
        question: 'Czy podpisana zgoda wyklucza dochodzenie roszczeń?',
        answer:
          'Nie automatycznie. Znaczenie ma nie tylko podpis, lecz także zakres i sposób przekazania informacji, dobrowolność zgody oraz to, czy dotyczyła ona wykonanej procedury. Osobno ocenia się prawidłowość samego leczenia.',
      },
      {
        question: 'Jak uzyskać dokumentację medyczną?',
        answer:
          'Pacjent może wystąpić do placówki o udostępnienie dokumentacji. Pierwsza kopia w żądanym zakresie jest co do zasady nieodpłatna, a dokumentacja powinna zostać udostępniona bez zbędnej zwłoki. Warto poprosić również o obrazy badań, formularze zgody i pełną historię leczenia związaną ze zdarzeniem.',
      },
      {
        question: 'Czy sprawę można rozwiązać bez procesu sądowego?',
        answer:
          'W zależności od okoliczności możliwe są rozmowy z placówką lub ubezpieczycielem, postępowanie przed Rzecznikiem Praw Pacjenta albo określona ścieżka kompensacyjna. Każda z tych dróg ma inny cel i skutek, dlatego najpierw warto ustalić, czego ma dotyczyć roszczenie.',
      },
      {
        question: 'Czy Fundusz Kompensacyjny dotyczy każdego błędu medycznego?',
        answer:
          'Nie. Fundusz obejmuje ustawowo określone zdarzenia związane z pobytem w szpitalu i świadczeniami finansowanymi ze środków publicznych. Sprawy dotyczące leczenia ambulatoryjnego, stomatologii lub medycyny estetycznej nie kwalifikują się do niego automatycznie.',
      },
      {
        question: 'Ile jest czasu na podjęcie działania?',
        answer:
          'Nie ma jednego terminu właściwego dla wszystkich spraw medycznych. Zależy on od podstawy roszczenia, daty zdarzenia, momentu uzyskania wiedzy o szkodzie i wybranego trybu. Termin należy obliczyć na podstawie konkretnej historii leczenia.',
      },
      {
        question: 'Czy od razu przesyłać całą dokumentację?',
        answer:
          'W pierwszej wiadomości wystarczy krótki opis, najważniejsze daty i informacja, jakie dokumenty są dostępne. Ponieważ dokumentacja zawiera szczególne dane o zdrowiu, sposób jej przekazania najlepiej wcześniej uzgodnić z kancelarią.',
      },
    ],
    relatedServices: [
      {
        label: 'Odszkodowania po wypadkach i za szkody',
        to: '/uslugi/odszkodowania',
      },
      {
        label: 'Umowy i spory cywilne',
        to: '/uslugi/prawo-cywilne',
      },
    ],
  },
  'kredyty-frankowe': {
    eyebrow: 'Prawo bankowe',
    title: 'Kredyty frankowe',
    intro:
      'Analizuję umowy kredytów indeksowanych i denominowanych w walucie obcej oraz pomagam ocenić ugodę, możliwość dochodzenia roszczeń i dalszy sposób działania.',
    situations: [
      'ocena umowy kredytu powiązanego z CHF, EUR lub JPY',
      'analiza propozycji ugody przedstawionej przez bank',
      'roszczenia dotyczące kredytu aktywnego lub już spłaconego',
      'reprezentacja w postępowaniu przeciwko bankowi',
    ],
    documents: [
      'umowa kredytowa wraz z załącznikami i regulaminem',
      'aneksy oraz późniejsze porozumienia z bankiem',
      'historia spłat lub zaświadczenie banku',
      'propozycja ugody i dotychczasowa korespondencja',
    ],
  },
  'prawo-pracy': {
    eyebrow: 'Prawo pracy',
    title: 'Pomoc prawna w sprawach pracowniczych',
    intro:
      'Doradzam pracownikom i pracodawcom w sporach dotyczących zatrudnienia, wypowiedzenia, wynagrodzenia i ubezpieczeń społecznych.',
    situations: [
      'odwołanie od wypowiedzenia lub rozwiązania umowy',
      'przywrócenie do pracy i odszkodowanie',
      'niewypłacone wynagrodzenie i inne należności',
      'ustalenie stosunku pracy oraz spory z ZUS',
    ],
    documents: [
      'umowa, aneksy i regulaminy obowiązujące w zakładzie',
      'wypowiedzenie lub inny kwestionowany dokument',
      'korespondencja i dowody dotyczące przebiegu zatrudnienia',
      'decyzje ZUS i wcześniejsze pisma w sprawie',
    ],
  },
  'prawo-karne': {
    eyebrow: 'Prawo karne',
    title: 'Obrona i reprezentacja pokrzywdzonych',
    intro:
      'Zapewniam pomoc osobom podejrzanym, oskarżonym i pokrzywdzonym na kolejnych etapach postępowania karnego.',
    situations: [
      'obrona przed Policją, prokuratorem i sądem',
      'udział w przesłuchaniu i przygotowanie do czynności',
      'reprezentacja osoby pokrzywdzonej przestępstwem',
      'sporządzanie i analiza pism procesowych',
    ],
    documents: [
      'wezwania, postanowienia i inne otrzymane pisma',
      'informacje o terminach zaplanowanych czynności',
      'posiadane materiały i korespondencja związane ze zdarzeniem',
      'krótka chronologia sprawy',
    ],
  },
  'prawo-cywilne': {
    eyebrow: 'Prawo cywilne',
    title: 'Umowy i spory cywilne',
    intro:
      'Sporządzam i opiniuję umowy, oceniam ryzyko prawne oraz reprezentuję klientów w sporach o zapłatę, wykonanie umowy i odszkodowanie.',
    situations: [
      'umowy usług, dzieła, pożyczki, najmu i sprzedaży',
      'wypowiedzenie, rozwiązanie lub niewykonanie umowy',
      'wezwanie do zapłaty i dochodzenie należności',
      'odszkodowanie za nienależyte wykonanie zobowiązania',
    ],
    documents: [
      'umowa, aneksy i regulaminy',
      'korespondencja dotycząca wykonania zobowiązania',
      'faktury, rachunki i potwierdzenia płatności',
      'wezwania, reklamacje i propozycje ugodowe',
    ],
  },
  'prawo-spadkowe': {
    eyebrow: 'Prawo spadkowe',
    title: 'Spadki i zachowek',
    intro:
      'Pomagam w sprawach dotyczących nabycia i odrzucenia spadku, testamentu, zachowku oraz rozliczeń między spadkobiercami.',
    situations: [
      'stwierdzenie nabycia spadku i dział spadku',
      'roszczenia o zachowek i obrona przed takim roszczeniem',
      'przyjęcie albo odrzucenie spadku',
      'ważność testamentu i spory między spadkobiercami',
    ],
    documents: [
      'akty stanu cywilnego i akt zgonu',
      'testamenty, akty notarialne i dokumenty darowizn',
      'informacje o składnikach oraz długach spadku',
      'dotychczasowa korespondencja między zainteresowanymi osobami',
    ],
  },
  'roboty-budowlane-i-remonty': {
    eyebrow: 'Prawo cywilne',
    title: 'Roboty budowlane i wadliwe remonty',
    intro:
      'Pomagam przygotować lub ocenić umowę oraz dochodzić roszczeń związanych z wadliwym, opóźnionym albo nieukończonym remontem lub robotami budowlanymi.',
    situations: [
      'analiza i przygotowanie umowy z wykonawcą',
      'wady prac wykończeniowych, montażowych i naprawczych',
      'opóźnienie, odstąpienie od umowy i rozliczenia',
      'wezwanie do usunięcia wad, zapłaty lub odszkodowania',
    ],
    documents: [
      'umowa, kosztorys, harmonogram i protokoły',
      'zdjęcia oraz opis stwierdzonych wad',
      'faktury, potwierdzenia płatności i wyceny napraw',
      'korespondencja z wykonawcą i wcześniejsze wezwania',
    ],
  },
  'prawo-gospodarcze-i-obsluga-spolek': {
    eyebrow: 'Dla przedsiębiorców',
    title: 'Prawo gospodarcze i obsługa spółek',
    intro:
      'Wspieram spółki i przedsiębiorców w bieżących sprawach prawnych, przygotowaniu dokumentów, umowach oraz zmianach zgłaszanych do KRS.',
    situations: [
      'bieżąca obsługa prawna przedsiębiorcy lub spółki',
      'umowy, uchwały i dokumenty korporacyjne',
      'zmiany umowy spółki, wspólników i kapitału',
      'wnioski i formularze do Krajowego Rejestru Sądowego',
    ],
    documents: [
      'aktualna umowa spółki i odpis KRS',
      'dotychczasowe uchwały oraz dokumenty korporacyjne',
      'opis planowanej zmiany lub transakcji',
      'projekty umów i korespondencja wymagająca analizy',
    ],
  },
};
